var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"design-row",style:([_vm.gridColumns, _vm.zIndex])},_vm._l((_vm.columns),function(col){return _c(col.tableComp,{key:col.key,tag:"component",class:{ 'double-right': col.border },attrs:{"columnKey":col.key}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }